import React from "react";
import { Col, Row } from "react-bootstrap";
var RedeemError = function (props) {
    return (React.createElement("div", { className: "error-block-state text-center bg_white px-5 py-5" },
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "taCenter pt-30 pb-30  mgt-25" },
                React.createElement("i", { className: "edel-icon-blocked txt_error_red" }))),
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12 },
                React.createElement("div", { className: "DMSanN_14_400 txt-Primary-gray" }, props.errorMsg ? props.errorMsg : "Something went wrong")))));
};
export default RedeemError;
